import React, { useState } from 'react';

const data = {
    Story1L: [
        {
            India: {
                Delhi: { numberOfViews: 50, uniqueviewers: 25 },
                Mumbai: { numberOfViews: 30, uniqueviewers: 10 },
                Kolkata: { numberOfViews: 20, uniqueviewers: 5 },
                numberOfViews: 100,
                uniqueviewers: 40,
            }
        },
        {
            'U.S.A.': {
                'Los Angeles': { numberOfViews: 80, uniqueviewers: 50 },
                'New York': { numberOfViews: 50, uniqueviewers: 15 },
                Chicago: { numberOfViews: 20, uniqueviewers: 10 },
                numberOfViews: 150,
                uniqueviewers: 75,
            }
        },
    ],
    Story1W: [
        {
            Japan: {
                Tokyo: { numberOfViews: 50, uniqueviewers: 25 },
                Osaka: { numberOfViews: 30, uniqueviewers: 10 },
                Sapporo: { numberOfViews: 20, uniqueviewers: 5 },
                numberOfViews: 100,
                uniqueviewers: 40,
            }
        },
        {
            Canada: {
                Toronto: { numberOfViews: 80, uniqueviewers: 50 },
                Vancouver: { numberOfViews: 50, uniqueviewers: 15 },
                Ottawa: { numberOfViews: 20, uniqueviewers: 10 },
                numberOfViews: 150,
                uniqueviewers: 75,
            }
        },
    ],
    Story2: [
        {
            Germany: {
                Berlin: { numberOfViews: 50, uniqueviewers: 25 },
                Hamburg: { numberOfViews: 30, uniqueviewers: 10 },
                Munich: { numberOfViews: 20, uniqueviewers: 5 },
                numberOfViews: 100,
                uniqueviewers: 40,
            }
        },
        {
            Albania: {
                Tirana: { numberOfViews: 80, uniqueviewers: 50 },
                Berat: { numberOfViews: 50, uniqueviewers: 15 },
                Elbasan: { numberOfViews: 20, uniqueviewers: 10 },
                numberOfViews: 150,
                uniqueviewers: 75,
            }
        },
    ],
    Combined: [
        {
            Qatar: {
                Doha: { numberOfViews: 50, uniqueviewers: 25 },
                Dukhan: { numberOfViews: 30, uniqueviewers: 10 },
                Mesaieed: { numberOfViews: 20, uniqueviewers: 5 },
                numberOfViews: 100,
                uniqueviewers: 40,
            }
        },
        {
            Morocco: {
                Rabat: { numberOfViews: 80, uniqueviewers: 50 },
                Fes: { numberOfViews: 50, uniqueviewers: 15 },
                Casablanca: { numberOfViews: 20, uniqueviewers: 10 },
                numberOfViews: 150,
                uniqueviewers: 75,
            }
        },
    ]
};

const Regions = () => {
    const [activeStory, setActiveStory] = useState('Story1L');

    const renderTable = (regions) => (
        <div className="tableStyle mt-5">
            <table>
                <thead>
                    <tr>
                        <th>Country</th>
                        <th>Region</th>
                        <th>Number of Views</th>
                        <th>Unique Viewers</th>
                    </tr>
                </thead>
                <tbody>
                    {regions.map((country, countryIndex) => (
                        Object.entries(country).map(([countryName, regions]) => (
                            <>
                                <tr key={countryName}>
                                    <td>{countryName}</td>
                                    <td></td>
                                    <td>{regions.numberOfViews}</td>
                                    <td>{regions.uniqueviewers}</td>
                                </tr>
                                {Object.entries(regions).map(([cityName, stats]) => (
                                    typeof stats === 'object' && (
                                        <tr key={`${countryName}-${cityName}`}>
                                            <td></td>
                                            <td>{cityName}</td>
                                            <td>{stats.numberOfViews}</td>
                                            <td>{stats.uniqueviewers}</td>
                                        </tr>
                                    )
                                ))}
                            </>
                        ))
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <>
            <div className="d-flex mt-5">
                {Object.keys(data).map((story, index) => (
                    <div
                        key={story}
                        onClick={() => setActiveStory(story)}
                        className={`usersNav ${activeStory === story ? 'usersNav-active' : ''} ${index !== 0 && 'ms-4'}`}
                    >
                        {story}
                    </div>
                ))}
            </div>
            {renderTable(data[activeStory])}
        </>
    );
}

export default Regions;
